import * as yup from "yup";
import BaseForm from "../../../../../../../../../shared/components/form/BaseForm";
import FormSelect from "../../../../../../../../../shared/components/select/FormSelect";

const AddCCAccessLevelRoleForm = ({ onSubmitHandler, roles }) => {
  const validationSchema = yup.object({
    role: yup.string().required("El rol de usuario es obligatorio"),
  });

  const defaultValues = {
    role: "",
  };

  return (
    <BaseForm
      onSubmitHandler={onSubmitHandler}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
    >
      <FormSelect name="role" label="Rol" options={roles} required />
    </BaseForm>
  );
};

export default AddCCAccessLevelRoleForm;
